module.exports = __webpack_public_path__ + "static/media/galerija_2022_0023.2d481b8b.jpg";